"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-page" };
const _hoisted_2 = { class: "columns" };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = { class: "check-box-container" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "check-box-title" }, "Szerviz típus", -1);
const _hoisted_6 = { class: "col" };
const _hoisted_7 = { class: "check-box-container" };
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "check-box-title" }, null, -1);
const _hoisted_9 = { class: "col" };
const _hoisted_10 = { class: "check-box-container" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "check-box-title" }, null, -1);
const Form_1 = require("../../../../components/Form");
const CustomSwitch_vue_1 = __importDefault(require("../../../../components/backend/CustomSwitch.vue"));
const CustomCheckbox_vue_1 = __importDefault(require("../../../../components/backend/CustomCheckbox.vue"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocationFormProperties',
    setup(__props) {
        const checkboxes = (0, vue_3.ref)({
            marso: { text: "Marso Partner", checked: true },
            nokian: { text: "Nokian Authorized Dealer", checked: false },
            bfgoodrich: { text: "BFGoodrich Dealer", checked: true },
            pex: { text: "Pneus Expert", checked: false },
            matador: { text: "Matador Authorized Dealer", checked: false },
            btk: { text: "BTK szervizpont", checked: true },
            bhp: { text: "BHP átvevő", checked: false },
            other: { text: "Egyéb", checked: false },
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            name: "vall_code",
                            label: "Vállalat kód"
                        }),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            name: "address_table_id",
                            label: "Address table ID"
                        }),
                        (0, vue_2.createVNode)(CustomSwitch_vue_1.default, {
                            name: "own_service",
                            text: "Saját szerviz",
                            checked: true
                        }),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            _hoisted_5,
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['marso'].checked,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((checkboxes.value['marso'].checked) = $event)),
                                name: "1",
                                text: checkboxes.value['marso'].text
                            }, null, 8, ["modelValue", "text"]),
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['nokian'].checked,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((checkboxes.value['nokian'].checked) = $event)),
                                name: "2",
                                text: checkboxes.value['nokian'].text
                            }, null, 8, ["modelValue", "text"]),
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['bfgoodrich'].checked,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((checkboxes.value['bfgoodrich'].checked) = $event)),
                                name: "3",
                                text: checkboxes.value['bfgoodrich'].text
                            }, null, 8, ["modelValue", "text"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            name: "telep_code",
                            label: "Telephely kód"
                        }),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            name: "address_rec_id",
                            label: "Address record id"
                        }),
                        (0, vue_2.createVNode)(CustomSwitch_vue_1.default, {
                            name: "franchise_service",
                            text: "Franchise szerviz",
                            checked: false
                        }),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            _hoisted_8,
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['pex'].checked,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((checkboxes.value['pex'].checked) = $event)),
                                name: "4",
                                text: checkboxes.value['pex'].text
                            }, null, 8, ["modelValue", "text"]),
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['matador'].checked,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((checkboxes.value['matador'].checked) = $event)),
                                name: "5",
                                text: checkboxes.value['matador'].text
                            }, null, 8, ["modelValue", "text"]),
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['btk'].checked,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((checkboxes.value['btk'].checked) = $event)),
                                name: "6",
                                text: checkboxes.value['btk'].text
                            }, null, 8, ["modelValue", "text"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            name: "axapta_code",
                            label: "Axapta customer code in MAR"
                        }),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            name: "address_num",
                            label: "Address number"
                        }),
                        (0, vue_2.createVNode)(CustomSwitch_vue_1.default, {
                            name: "atvevo_hely",
                            text: "Átvevő hely",
                            checked: false
                        }),
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            _hoisted_11,
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['bhp'].checked,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((checkboxes.value['bhp'].checked) = $event)),
                                name: "7",
                                text: checkboxes.value['bhp'].text
                            }, null, 8, ["modelValue", "text"]),
                            (0, vue_2.createVNode)(CustomCheckbox_vue_1.default, {
                                modelValue: checkboxes.value['other'].checked,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((checkboxes.value['other'].checked) = $event)),
                                name: "6",
                                text: checkboxes.value['other'].text
                            }, null, 8, ["modelValue", "text"])
                        ])
                    ])
                ])
            ]));
        };
    }
});
